import { Container, Row, Col, Spinner } from "react-bootstrap";

export default function Loading({ children = null, inline = false, inlineHeight = 400 }) {
  return (
    <Container fluid className={"bplaced-wrapper"}>
      <Row>
        <Container fluid>
          <Col
            md={12}
            className="d-flex flex-column align-items-center justify-content-center"
            style={{ height: inline ? inlineHeight : "100vh" }}
          >
            <div>
              <Spinner animation="border" role="status" variant={"secondary"}>
                <span className="visually-hidden">Loading</span>
              </Spinner>
            </div>

            <div style={{ marginTop: 10 }}>{children}</div>
          </Col>
        </Container>
      </Row>
    </Container>
  );
}
